export default class NftNotAvailableError extends Error {
    constructor(message, tokenAcct, mint) {
        super(message);
        this.name = "NftNotAvailableError";
        this.tokenAddress = tokenAcct.toBase58();
        this.mintAddress = mint.toBase58();
    }
}
